import { Flex, FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface MainContentProps {
  children: ReactNode;
}

const MainContent: React.FC<FlexProps & MainContentProps> = ({
  children,
  ...rest
}) => {
  return (
    <Flex
      p={8}
      bg="#F9F9F9"
      w="100%"
      direction="column"
      overflow="hidden"
      overflowY="auto"
      maxH="100svh"
      {...rest}
    >
      {children}
    </Flex>
  );
};

export default MainContent;
